import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { Actions, Link } from 'ui-kit/actions'
import { Picture } from 'ui-kit/picture'
import { DOCS_LINK } from 'routes/constants'
import { BookCalendlyLink } from 'routes/components/Shared'
import Workflow1x from './workflow-builder@1x.avif'
import Workflow2x from './workflow-builder@2x.avif'
import classes from './WorkflowAutomationToolsHero.module.scss'

export const WorkflowAutomationToolsHero = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <div className={classes.content}>
        <Heading as={'h1'} size={'xxl'} center className={classes.title}>
          Integration Layer for Workflow Automation Tools
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          Supercharge your app by adding all the connectors your customers need.
        </Text>
        <Actions className={classes.actions}>
          <BookCalendlyLink
            type={'primary'}
            showIcon={false}
            className={classes.button}
          >
            Schedule a personalized demo
          </BookCalendlyLink>
          <Link
            href={DOCS_LINK}
            type={'secondary'}
            target={'_blank'}
            asPageButton
            className={classes.button}
          >
            Read the docs
          </Link>
        </Actions>
      </div>
      <div className={classes.visual}>
        <Picture
          className={classes.image}
          src1x={Workflow1x.src}
          src2x={Workflow2x.src}
          noBreakpoint={true}
          width={453}
          height={325}
          fetchPriorityHigh
          alt='Workflow Automation Tools'
        />
      </div>
    </Block>
  )
}
